<template>
    <div>
        <div class="row no-gutters align-center justify-center mb-5" v-if="showCarousel">
            <div class="col col-12 px-md-5">
                <carousel
                    :carousel-settings="carouselSettings">
                    <div v-for="(program, index) in programs" :key="index">
                        <program-card
                            :title="program.name"
                            :description="program.description"
                            :illustration="program.illustration.url"
                            :modulesNumber="program.progress ? program.progress.modules : null"
                            :missionsNumber="program.progress ? program.progress.missions: null"
                            :button-text="trans('streams.dashboard.start_now')"
                            :button-disabled="buttonDisabled"
                            @ctaClicked="handleProgramSelection(program)"
                        />
                    </div>
                </carousel>
            </div>
        </div>
        <div class="row justify-content-center mb-5 px-md-5" v-else>
            <div class="col-12 col-lg-6 px-3 px-lg-0" v-for="(program, index) in programs" :key="index">
                <program-card
                    :title="program.name"
                    :description="program.description"
                    :illustration="program.illustration.url"
                    :modulesNumber="program.progress ? program.progress.modules : null"
                    :missionsNumber="program.progress ? program.progress.missions: null"
                    :button-text="trans('streams.dashboard.start_now')"
                    :button-disabled="buttonDisabled"
                    @ctaClicked="handleProgramSelection(program)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import roleMixin from "../mixins/roleMixin";
    import Carousel from '../molecules/Carousel';
    import ProgramCard from '../molecules/cards/ProgramCard';

    export default {
        name: "ServiceListProgram",
        components: { Carousel, ProgramCard },
        props: {
            programs: Array,
            buttonDisabled: Boolean,
            showCarousel: Boolean
        },
        data(){
            return{
                carouselSlidesMobile: 1,
                carouselSlidesTablet: 2,
                carouselSlidesDesktop: 2,
                carouselSettings: {
                    "arrows": true,
                    "dots": true,
                    "speed": 500,
                    "slidesToShow": 2,
                    "slidesToScroll": 1,
                    "initialSlide": 0,
                    "infinite": false,
                    "responsive": [
                        {
                            "breakpoint": 720,
                            "settings": {
                                "slidesToShow": 1,
                                "arrows": false
                            }
                        }
                    ]
                }
            }
        },
        methods:{
            handleProgramSelection(service){
                this.$emit('onAction', { actionType: 'master', serviceType: service.serviceType, serviceId: service.code });
                this.checkService(service.id, service.serviceType)
            }
        },
        mixins:[roleMixin]
    }
</script>
